import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { auth } from '../services/auth';
import { deletePost } from '../services/blog';
import styles from '../css/blog.module.css';

export default function BlogCard({
    post,
    blogKey,
    idx,
    handleDelete,
}) {
    const [deleting, setDeleting] = useState(false);
    const [hasError, setHasError] = useState(false);

    const isAdmin = auth().isAdmin();
    const token = auth().getToken();
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    }

    const removePost = (id) => {
        if (window.confirm("Are you sure you want to delete?")) {
            setDeleting(true);
            deletePost(id, config)
                .then((response) => {
                    handleDelete(post.id);
                    setHasError(false);
                })
                .catch((error) => {
                    setHasError(true);
                })
                .finally(() => {
                    setDeleting(false);
                });
        }
    }

    return (
        <article className="" key={blogKey}>
            <Link to={`/blog/view/${post.id}`} className="hover:opacity-90 transition-all">
                <img className={styles.blogImage} id={idx} src={post.image} alt={post.name} />
                <h2 className="text-xl font-semibold my-5 h-10">{post.name}</h2>
            </Link>
            <div className={styles.blogParagraph} dangerouslySetInnerHTML={{ __html: post.description }} />
            {isAdmin ? (
                <>
                    <div className="flex flex-row justify-between mt-3">
                        <Link to={`/blog/edit/${post.id}`} className={styles.editPostBtn}>Edit</Link>
                        <button disabled={deleting} onClick={() => removePost(post.id)} className={styles.deletePostBtn}>Delete</button>
                    </div>
                    <div className="flex flex-row justify-end mt-3">
                        {hasError === post.id ? (
                            <p className="text-red-600">Failed deleting post.</p>
                        ) : null}
                    </div>
                </>
            ) : null}
        </article>
    )
}